import { jsx as _jsx } from "react/jsx-runtime";
import { Link, useLocation, useNavigate } from '@ui/app-router';
import { cn } from '@ui/primitives/utils';
const baseTabClass = 'px-4 py-4 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2';
const activeTabClass = 'text-foreground border-brand-400';
const inactiveTabClass = 'text-muted-foreground border-transparent hover:text-foreground';
export function NavTabs(param) {
    let { items, className, 'data-e2e': dataE2e } = param;
    const navigate = useNavigate();
    const location = useLocation();
    const handleKeyDown = (e, currentIndex)=>{
        let nextIndex;
        if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % items.length;
        else if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + items.length) % items.length;
        else return;
        e.preventDefault();
        const nextItem = items[nextIndex];
        if (nextItem) {
            void navigate({
                to: nextItem.to
            });
        }
    };
    if (!items.length) return null;
    return /*#__PURE__*/ _jsx("nav", {
        className: cn('flex items-center overflow-x-auto scrollbar-hide h-15', className),
        "data-e2e": dataE2e,
        role: "tablist",
        children: items.map((item, index)=>{
            var _item_includeSearch;
            // Custom active detection for items with activeBasePath
            const isActiveByBasePath = item.activeBasePath ? location.pathname.startsWith(item.activeBasePath) : undefined;
            return /*#__PURE__*/ _jsx(Link, {
                to: item.to,
                role: "tab",
                onKeyDown: (e)=>handleKeyDown(e, index),
                className: cn(baseTabClass, // When activeBasePath is set, use manual active state
                isActiveByBasePath !== undefined && (isActiveByBasePath ? activeTabClass : inactiveTabClass)),
                activeOptions: item.exact ? {
                    exact: true,
                    includeSearch: (_item_includeSearch = item.includeSearch) !== null && _item_includeSearch !== void 0 ? _item_includeSearch : true
                } : undefined,
                // Only use activeProps/inactiveProps when NOT using activeBasePath
                activeProps: isActiveByBasePath === undefined ? {
                    className: activeTabClass
                } : undefined,
                inactiveProps: isActiveByBasePath === undefined ? {
                    className: inactiveTabClass
                } : undefined,
                "data-e2e": "LAYOUT_NAVIGATION_MENU__".concat(item.title.toUpperCase(), "__BUTTON"),
                children: item.title
            }, item.id);
        })
    });
}
